import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartWishlistProvider } from "@/context/CartWishlistContext";
import "@/App.css";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Auctions from "@/pages/Auctions";
import AuctionDetail from "@/pages/AuctionDetail";
import Community from "@/pages/Community";
import DiscussionDetail from "@/pages/DiscussionDetail";
import Collections from "@/pages/Collections";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import Profile from "@/pages/Profile";
import AuthCallback from "@/pages/AuthCallback";
import Wishlist from "@/pages/Wishlist";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminProducts from "@/pages/admin/Products";
import AdminOrders from "@/pages/admin/Orders";
import AdminUsers from "@/pages/admin/Users";
import AdminAuctions from "@/pages/admin/Auctions";
import AdminOffers from "@/pages/admin/Offers";
import AdminDiscussions from "@/pages/admin/Discussions";
import AdminReviews from "@/pages/admin/Reviews";
import AdminCollections from "@/pages/admin/Collections";
import AdminWishlists from "@/pages/admin/Wishlists";
import AdminCategory from "@/pages/admin/Category";
import AdminMedia from "@/pages/admin/Media";
import PaymentCallback from "@/pages/PaymentCallback";
import AdminProductType from "@/pages/admin/Producttypes";


function App() {
  return (
    <div className="App">
      <CartWishlistProvider>
        <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/auctions" element={<Auctions />} />
          <Route path="/auction/:id" element={<AuctionDetail />} />
          <Route path="/community" element={<Community />} />
          <Route path="/discussion/:id" element={<DiscussionDetail />} />
          <Route path="/collections" element={<Collections />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/auth-callback" element={<AuthCallback />} />
          <Route path="/payment/callback" element={<PaymentCallback />} /> {/* Added by danish for instamojo integration */}

          
          {/* Admin Routes */}
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/products" element={<AdminProducts />} />
          <Route path="/admin/orders" element={<AdminOrders />} />
          <Route path="/admin/users" element={<AdminUsers />} />
          <Route path="/admin/auctions" element={<AdminAuctions />} />
          <Route path="/admin/offers" element={<AdminOffers />} />
          <Route path="/admin/discussions" element={<AdminDiscussions />} />
          <Route path="/admin/reviews" element={<AdminReviews />} />
          <Route path="/admin/collections" element={<AdminCollections />} />
          <Route path="/admin/wishlists" element={<AdminWishlists />} />
          <Route path="/admin/category" element={<AdminCategory />} />
          <Route path="/admin/media" element={<AdminMedia />} />
          <Route path="/admin/Producttypes" element={<AdminProductType />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
      </CartWishlistProvider>
    </div>
  );
}

export default App;